class CvAnnouncementBar extends HTMLElement {
	connectedCallback() {
		this.track = this.querySelector(".cv-announcement-bar__track");
		const slides = [...this.track.querySelectorAll("[data-slide]")];
		if (slides.length <= 1) return;

		this.slideCount = slides.length;
		this.index = 0;
		this.intervalMs = Number(this.dataset.intervalMs);
		this.autoAdvance = !matchMedia("(prefers-reduced-motion: reduce)").matches;
		this.abort = new AbortController();
		const { signal } = this.abort;

		this.appendClones(slides);
		this.jumpTo(0);

		this.track.addEventListener("scrollend", () => this.handleScrollEnd(), {
			signal,
		});
		window.addEventListener("resize", () => this.jumpTo(this.index), {
			signal,
		});
		signal.addEventListener("abort", () => clearInterval(this.timer));

		this.restartTimer();
	}

	disconnectedCallback() {
		this.abort?.abort();
	}

	get width() {
		return this.track.clientWidth;
	}

	jumpTo(newIndex) {
		this.index = newIndex;
		this.track.scrollLeft = (newIndex + 1) * this.width;
	}

	advance() {
		if (this.matches(":hover")) return;
		if (this.contains(document.activeElement)) return;
		this.track.scrollTo({
			left: (this.index + 2) * this.width,
			behavior: "smooth",
		});
	}

	handleScrollEnd() {
		const position = Math.round(this.track.scrollLeft / this.width);
		if (position === 0) this.jumpTo(this.slideCount - 1);
		else if (position === this.slideCount + 1) this.jumpTo(0);
		else this.index = position - 1;
		this.restartTimer();
	}

	restartTimer() {
		clearInterval(this.timer);
		if (!this.autoAdvance) return;
		this.timer = setInterval(() => this.advance(), this.intervalMs);
	}

	appendClones(slides) {
		for (const [source, position] of [
			[slides.at(-1), "afterbegin"],
			[slides[0], "beforeend"],
		]) {
			const clone = source.cloneNode(true);
			clone.setAttribute("aria-hidden", "true");
			for (const focusable of clone.querySelectorAll("a, button")) {
				focusable.setAttribute("tabindex", "-1");
			}
			this.track.insertAdjacentElement(position, clone);
		}
	}
}

if (!customElements.get("cv-announcement-bar")) {
	customElements.define("cv-announcement-bar", CvAnnouncementBar);
}
